import {
  useFacetContext,
  useRouterContext,
} from '../../../../context/PlpContext';

export const useFacetItemData = () => {
  const router = useRouterContext();
  const facetContext = useFacetContext();

  return {
    router,
    facetContext,
  };
};
